"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Img = function Img(props) {
  if (props.sizes) {
    return _react.default.createElement("img", _extends({
      srcSet: "".concat(props.sizes.medium, " 480w, ").concat(props.sizes.medium_large, " 800w, ").concat(props.sizes.large, " 1024w, ").concat(props.sizes.x_large, " 2000w"),
      sizes: "100vw",
      src: props.sizes.large,
      alt: props.alt
    }, props));
  }

  return _react.default.createElement("img", _extends({
    src: props.src,
    alt: props.alt
  }, props));
};

var _default = Img;
exports.default = _default;